import { render, staticRenderFns } from "./DetailFlashSale.vue?vue&type=template&id=2904c4e7&"
import script from "./DetailFlashSale.vue?vue&type=script&lang=js&"
export * from "./DetailFlashSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports